import React, { type ReactNode } from "react";

type ModalProps = {
  isOpen: boolean;
  width: string;
  children: ReactNode;
  outerClassName?: string;
  innerClassName?: string;
  bgColor?: string;
};

const CalendarModal = ({
  children,
  isOpen,
  width,
  outerClassName = "",
  innerClassName = "",
  bgColor = "dark:bg-sleap-gray-950 bg-lightwhite dark:text-lightwhite text-sleap-gray-950",
}: ModalProps) => {
  return (
    isOpen && (
      <div className="modal-overlay z-40 modal-open">
        <div className={`${width} relative shadow ${outerClassName}`}>
          <div className={`${bgColor} ${innerClassName}`}>
            <div className="h-screen gallery-modal relative">{children}</div>
          </div>
        </div>
      </div>
    )
  );
};

export default CalendarModal;
